import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer style={{
      padding: '40px 0 20px', 
      backgroundColor: 'white', 
      color: 'var(--dark)', 
      textAlign: 'center', 
      width: '100%', 
      boxShadow: '0 -2px 15px rgba(0, 0, 0, 0.1)', 
      marginTop: '40px'
    }}>
      <div className="container">
        <div style={{
          fontSize: '1.5rem', 
          fontWeight: '800', 
          color: 'var(--primary)', 
          marginBottom: '10px'
        }}>
          Nexly<span style={{color: 'var(--secondary)'}}>Digital</span>
        </div>
        <p style={{
          marginBottom: '20px', 
          color: 'var(--dark)', 
          fontSize: '0.9rem'
        }}>
          Driving digital innovation across industries with AI, automation, and modern solutions.
        </p>
        <div style={{
          borderTop: '1px solid #ddd', 
          paddingTop: '15px', 
          marginTop: '15px'
        }}>
          <p style={{margin: '0', fontSize: '0.8rem'}}>
            © 2025 Nexly Digital. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;